import { createSlice } from "@reduxjs/toolkit";
import { User, Meta } from "src/store/types";
import { doBanUnbanUser, doFetchUserList } from "./user.action";

interface userState {
  users: User[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
  searchQuery: string;
}

const initialState: userState = {
  users: [] as User[],
  meta: null,
  loading: false,
  error: null,
  searchQuery: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = "";
    },
  },
  extraReducers: (builder) => {
    // fetch user list
    builder
      .addCase(doFetchUserList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // ban/unban user
    builder
      .addCase(doBanUnbanUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doBanUnbanUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
      })
      .addCase(doBanUnbanUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Export actions
export const { setSearchQuery, clearSearch } = userSlice.actions;

export default userSlice.reducer;
